import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}

    .heading {
        font-weight: normal;
        background-color: darkslategrey;
        padding: 1em;
        border-radius: 0.5em;
    }

    .footer {
        justify-content: end;
        border-top: solid var(--border-width) var(--border-color);
        padding: 1em;
        padding-bottom: 0;
        margin: 0;
    }
`;
